import { getImageMimeType } from "../Components/M44MediaViewer/utils";
const noOpCleanup = () => {
};
export const insertImagePreloadLink = (imgUrl) => {
    if (!imgUrl) {
        return noOpCleanup;
    }
    if (typeof document === "undefined") {
        return noOpCleanup;
    }
    try {
        if (!document.head) {
            console.warn("insertImagePreloadLink: document.head is not available");
            return noOpCleanup;
        }
        const existingLinks = document.head.querySelectorAll("link[rel='preload'][as='image']");
        const existingLink = Array.from(existingLinks).find(link => link.href === imgUrl);
        if (existingLink) {
            return noOpCleanup;
        }
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = imgUrl;
        link.type = getImageMimeType(imgUrl) || "";
        link.setAttribute("fetchpriority", "high");
        document.head.appendChild(link);
        return () => {
            if (link.parentNode) {
                link.remove();
            }
        };
    }
    catch (error) {
        console.error("insertImagePreloadLink failed:", error, "URL:", imgUrl);
        return noOpCleanup;
    }
};
